import React from 'react';
import {LiveStreamingModuleProps} from "../models/live-streaming-module.props";
import {Link} from "../../../../../core/components/link/link";
import {LINK_REL} from "../../../../../core/consts";

export class LiveStreamingModuleBookmakerProps extends LiveStreamingModuleProps {
  onClick: Function;
}

export const LiveStreamingModuleButton = (props: LiveStreamingModuleBookmakerProps) => {
  const containerProps = {
    className: 'live-streaming-module-button',
    onClick: () => props?.onClick(),
    model: props.bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER
}

  return (
    <Link {...containerProps}>
      <div className={'live-streaming-module-triangle'}/>
    </Link>
  )
};